import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchResumeData } from '../fetchProjects';

const GlobalContext = createContext();

export const useGlobalContext = () => useContext(GlobalContext);

const WORKER_URL = 'https://spaceportfolio-api.rajansudhan0.workers.dev';

export const GlobalProvider = ({ children }) => {
  const [globalSettings, setGlobalSettings] = useState(null);
  const [resumeUrl, setResumeUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${WORKER_URL}/api/settings?t=${Date.now()}`, {
          cache: 'no-store'
        });
        if (response.ok) {
          const data = await response.json();
          setGlobalSettings(data);
        }
      } catch (error) {
        console.error('Error fetching global settings:', error);
      }
    };

    const fetchResume = async () => {
      try {
        const resumes = await fetchResumeData();
        const activePdf = resumes.find(r => r.type === 'pdf' && r.is_active);
        if (activePdf) {
          setResumeUrl(activePdf.file_url);
        }
      } catch (error) {
        console.error('Error fetching active resume:', error);
      }
    };

    Promise.all([fetchSettings(), fetchResume()]).finally(() => {
      setLoading(false);
    });
  }, []);

  return (
    <GlobalContext.Provider value={{ globalSettings, resumeUrl, loading }}>
      {children}
    </GlobalContext.Provider>
  );
};
